import { render } from "./MyListsLayout.vue?vue&type=template&id=1dcd50ed&scoped=true"
import script from "./MyListsLayout.vue?vue&type=script&lang=js"
export * from "./MyListsLayout.vue?vue&type=script&lang=js"

import "./MyListsLayout.vue?vue&type=style&index=0&id=1dcd50ed&lang=scss&scoped=true"
/* custom blocks */
import block0 from "@/locales/components/layouts/my-lists-layout.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Fapp%2Fsrc%2Fcomponents%2Flayouts%2FMyListsLayout.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dcd50ed"]])

export default __exports__